// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--izJBY","cursor_pointer":"a10a3f92e9--cursor_pointer--jM4Gv"};